<mat-progress-bar
  [class.visible]="loader.value$ | async"
  [value]="loader.value$ | async"
  class="progress-bar"
  mode="determinate"
></mat-progress-bar>
